import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { NumberUtils } from 'src/app/utils/number-utils';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { ElementsService } from 'src/app/services/elements/elements.service';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { BdtCatalogoEquipamientoModel } from 'src/app/services/bdt/models/bdt-catalogo-equipamiento.model';
import { SsoService } from 'src/app/services/sso/sso.service';

@Component({
  selector: 'app-elementos-select',
  templateUrl: './elementos-select.component.html',
  styleUrls: ['./elementos-select.component.css']
})
export class ElementosSelectComponent implements OnInit {

  @ViewChild('grid') grid: jqxGridComponent;

  @Input() conCerradura: boolean;
  @Output() passArray = new EventEmitter;
  modelosSelect: BdtCatalogoEquipamientoModel[] = [];
  // Para la cabecera del grid
  private static toolbarContainer = null;
  private static searchControl = null;

  private componentRef = null;
  public theme = environment.tema;

  //objetos
  elemento: ElementoModel = new ElementoModel();
  elementos: ElementoModel[] = [];
  //grid
  dataSource: any
  dataAdapter: any;
  checkSelect: ElementoModel[] = [];
  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  public columns = [

    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true },
    { text: '', columntype: 'image', datafield: 'imagen', cellsrenderer: this.imagerenderer, autowidth: true },
    {
      text: AppComponent.translate('Descripcion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 201,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true, width: 1 }
  ];


  constructor(private ssoService: SsoService) { }
  ngOnInit(): void {
    //this.filterElementos(this.conCerradura);
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.getElementos();
  }



  ngAfterViewInit(): void {
    this.initGridHeader();
    this.grid.selectallrows();
  }


  selectModelos(elem: BdtCatalogoEquipamientoModel[]): void {
    this.modelosSelect = elem;
    this.filterModelosSelect();
  }

  filterModelosSelect() {
    if (this.modelosSelect.length) {
      this.elementos = this.elementos.filter((modelo) => {
        return this.modelosSelect.some((elem) => elem.Equipamiento.Modelo.Id == modelo.Equipamiento.Modelo.Id);
      });
      this.dataSource.localdata = this.elementos;
      let elementos = this.grid.getrows();
      elementos.forEach(elem => {
        this.grid.selectrow(elem.boundindex);
      });

      this.grid.updatebounddata(this.elementos);
    }
  }

  // filtro los elementos
  filterElementos(conCerradura: boolean): ElementoModel[] {
    // recupero los elementos
    this.elementos = MainComponent.getInstance().elementsList;
    // Solo muestro los elementos que tienen cerradura
    if (conCerradura) {
      this.elementos = this.elementos.filter(elemento => elemento.cerradura.id !== 0);
    }
    return this.elementos;
  }

  // obtengo los elementos
  getElementos() {
    this.elementos = this.filterElementos(true);
    if (this.elementos) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'imagen', type: 'image', map: 'Equipamiento>Icono' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'selec', map: 'selec', type: 'string' }
        ],
        localdata: this.elementos,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      };
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
    } else {
      this.elementos = [];
    }

    const t = setTimeout(() => {
      clearTimeout(t);
      this.grid.autoresizecolumns();
    }, 500);
  }

  /**Inicializa el componente
  */
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  onSelect(event: any) {
    // si se seleccionan todos los elementos del grid
    switch (event.args.rowindex.length) {
      case 0:
        this.checkSelect = [];
        break;
      default:
        let rows: any[] = this.grid.getrows();
        let idRow: number[] = this.grid.getselectedrowindexes();
        rows.forEach((element, index) => {
          this.elemento = this.elementos.find((elem) => elem.Id == element.id && idRow[index] == element.boundindex);
          this.checkSelect.push(this.elemento);
        });
        this.checkSelect = this.onChangeArray(this.checkSelect);
        break;
    }
    this.passArray.emit(this.checkSelect);
  }

  // deseleccion de elementos en el grid modelos
  onUnselect(event) {
    let row: any = this.grid.getrowdatabyid(event.args.rowindex);
    // elimino el elemento deseleccionado del array checkSelect
    this.checkSelect.splice(this.checkSelect.indexOf(row), 1);
    this.passArray.emit(this.checkSelect);
  }

  // si cmabia el array del checkSelect
  onChangeArray(list: ElementoModel[]): ElementoModel[] {
    // quito los elementos repetidos del array
    list = list.filter((elem, index, self) =>
      index == self.findIndex((t) => t?.Id == elem?.Id) && elem !== undefined
    );
    this.checkSelect = list;
    return this.checkSelect;
  }

  onChange(event: any) {
  }


  ngOnDestroy(): void {

  }


  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
  // Inicializa los controles de la cabecera del grid
  initGridHeader(): void {
    if (ElementosSelectComponent.searchControl) {
      ElementosSelectComponent.searchControl.addEventListener('input', (event: any) => {
        const searchText = event.target.value.toUpperCase();
        this.elementos.forEach(movil => {
          if ((movil['Nombre'] && movil['Nombre'].toUpperCase().indexOf(searchText) > -1)) {
            movil['selec'] = 'selec';
          } else {
            movil['selec'] = '';
          }
        });
        // Compruebo si ya he creado el filtro "selec" anteriormente
        const filters = this.grid.getfilterinformation();
        if (filters.find(s => s.datafield === 'selec') === undefined) {
          const filtergroup = new jqx.filter();
          filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
          this.grid.addfilter('selec', filtergroup);
        }
        this.grid.applyfilters();
        this.grid.updatebounddata('data');
      });
    }
  }

  createToolBar(statusbar: any) {
    if (statusbar[0] !== undefined) {
      // Añado el control de búsqueda a la cabecera
      ElementosSelectComponent.toolbarContainer = document.createElement('div');
      ElementosSelectComponent.toolbarContainer.style.cssText = 'overflow: hidden; position: relative; margin-left: 3px; margin-top: 0px';
      ElementosSelectComponent.toolbarContainer.id = 'movilesSelec' + Math.random().toString(16).substring(2);
      ElementosSelectComponent.searchControl = document.createElement('div');
      ElementosSelectComponent.searchControl.id = 'searchControl' + Math.random().toString(16).substring(2);
      ElementosSelectComponent.searchControl.style.cssText = `
          float: left;
          background-color: white;
          background-image: url('../assets/images/search.png');
          background-repeat: no-repeat;
          background-position: 4px center;
          background-size: 18px;
          display: flex;
          align-items: center;
          width: 99%;
          margin-top: 3px;
          padding-top: 2px;
          padding-left: 28px;
          height: 24px;
          border: 1px solid rgba(0, 0, 0, 0.5);
          border-radius: 3px;
          overflow: hidden;
        `;
      ElementosSelectComponent.searchControl.innerHTML = '<input type="text" style="border: 0;width: 100%; outline: none;" (keydown.enter)="$event.preventDefault()" ' +
        'placeholder="' + MainComponent.getInstance().translate('Buscar') + '..." autocorrect = "off" autocapitalize = "off" spellcheck = "off">';
      ElementosSelectComponent.toolbarContainer.appendChild(ElementosSelectComponent.searchControl);
      statusbar[0].appendChild(ElementosSelectComponent.toolbarContainer);
    }
  }

  imagerenderer(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    return '<img style="margin-left: 4px; margin-top: 8px;" height="16" width="16" src="data:image/jpg;base64,' + value + '"/>'
  }
}
